import axiosInstance from "../../api/axiosInstance";

export const fetchPaginatedUsersAPI = async (page, limit) => {
  const usersList = await axiosInstance.get(
    `users/get-paginated-users?page=${page}&limit=${limit}`,
  );

  return usersList.data;
};

export const deleteUserAPI = async (id) => {
  const deletedUser = await axiosInstance.delete(`users/delete-user/${id}`);

  return deletedUser.data;
};

export const adminBanUserAPI = async (id, banned) => {
  const updatedUser = await axiosInstance.patch(`users/admin/${id}`, {
    banned,
  });

  return updatedUser.data;
};

export const deleteUserGameIdAPI = async (gameIdDocId) => {
  const deletedGameId = await axiosInstance.delete(
    `gameids/delete-gameid/${gameIdDocId}`,
  );

  return deletedGameId.data;
};
